import { useAuth } from '../../contexts/SecurityContext';

const RoleGuard = ({ 
  children, 
  role = null, 
  roles = null, 
  requireAuth = false,
  fallback = null 
}) => {
  const { isAuthenticated, hasRole, hasAnyRole } = useAuth();

  // If authentication is required and user is not authenticated
  if (requireAuth && !isAuthenticated) {
    return fallback;
  }

  // If specific role is required
  if (role && !hasRole(role)) {
    return fallback;
  }

  // If any of multiple roles is required
  if (roles && !hasAnyRole(roles)) {
    return fallback;
  }

  // User has access, render the content
  return children;
};

export default RoleGuard;
